module.exports = __webpack_public_path__ + "img/pic_a.f2c8d7a0.png";